<template>
  <v-list v-if="normalizedDiff" dense>
    <template v-for="(diffList, country) in normalizedDiff">
      <div :key="`${country}-title`">{{ capitalize(country) }}</div>
      <diff-value v-for="property in diffList" :key="`${country}-${property.title}-diff`" :diff="property" />
    </template>
  </v-list>
</template>

<script>
import { capitalize, uniq } from 'lodash-es'

import DiffValue from '@/components/object-diff/diff-value'

import DataModification from '@/mixins/data-modification'

export default {
  name: 'ObjectDiff',
  components: {
    DiffValue,
  },
  mixins: [DataModification],
  props: {
    original: {
      type: Object,
      required: true,
    },
    updated: {
      type: Object,
      required: true,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  computed: {
    diff() {
      const countries = uniq(Object.keys(this.original), Object.keys(this.updated))

      return countries.reduce((diffList, country) => {
        diffList[country] = this.getDiff(this.original[country] || {}, this.updated[country] || {})
        return diffList
      }, {})
    },
    normalizedDiff() {
      if (!this.diff) return []
      return Object.entries(this.diff).reduce((diffsByGeo, [country, diffs]) => {
        if (!diffs) return diffsByGeo
        const diffObj = diffs.reduce((diffData, diff) => {
          const [propertyKey] = diff.path
          const { context, option, title } = this.getPropertyDataFromSchema(this.schema, propertyKey)

          const changes = this.buildChangesArray(diff, { context, option })

          if (diffData[title]) {
            diffData[title].changes = diffData[title].changes.concat(changes)
          } else {
            diffData[title] = {
              changes,
              title,
            }
          }

          return diffData
        }, {})

        diffsByGeo[country] = diffObj

        return diffsByGeo
      }, {})
    },
  },
  methods: {
    capitalize(val) {
      return capitalize(val)
    },
    buildChangesArray({ kind, item, path, lhs, rhs }, { context, option }) {
      const [, contextKey] = path
      const contextLabel = this.getContextLabel(context, contextKey)
      const isArrayChange = this.isArrayChange(kind, path)

      if (!isArrayChange) {
        const type = this.getDiffType({ kind, item, lhs, rhs })
        return [
          this.createChange(
            contextLabel,
            type,
            this.formatDiffKey(option, this.getDiffValue({ item, lhs, rhs }, type))
          ),
        ]
      } else
        return [
          this.createChange(
            contextLabel,
            this.getDiffType({ kind: 'D', item, lhs, rhs }),
            this.formatDiffKey(option, lhs)
          ),
          this.createChange(
            contextLabel,
            this.getDiffType({ kind: 'N', item, lhs, rhs }),
            this.formatDiffKey(option, rhs)
          ),
        ]
    },
  },
}
</script>
